import { render, staticRenderFns } from "./official-factor.vue?vue&type=template&id=6c551cc0"
import script from "./official-factor.vue?vue&type=script&lang=js"
export * from "./official-factor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports